"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var PasswordStrengthIndicator = /** @class */ (function (_super) {
    __extends(PasswordStrengthIndicator, _super);
    function PasswordStrengthIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PasswordStrengthIndicator.prototype.render = function () {
        var _a = this.props, strength = _a.strength, className = _a.className;
        var customProps = _1.omit(this.props, Object.keys(PasswordStrengthIndicator.propTypes));
        var defaultStrengthText = '';
        var rootClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('password-strength')] = true,
            _b[vdl_prefix_1.vdlPrefix('password-strength--weak')] = strength === 1,
            _b[vdl_prefix_1.vdlPrefix('password-strength--fair')] = strength === 2,
            _b[vdl_prefix_1.vdlPrefix('password-strength--good')] = strength === 3,
            _b[vdl_prefix_1.vdlPrefix('password-strength--strong')] = strength === 4,
            _b);
        switch (strength) {
            case 1:
                defaultStrengthText = 'Weak';
                break;
            case 2:
                defaultStrengthText = 'Fair';
                break;
            case 3:
                defaultStrengthText = 'Good';
                break;
            case 4:
                defaultStrengthText = 'Strong';
                break;
        }
        var strengthText = ('strengthText' in this.props ? this.props.strengthText : defaultStrengthText);
        return (React.createElement("div", null,
            React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(className, rootClasses) }),
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('password-strength__bars') },
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('password-strength__bar') }),
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('password-strength__bar') }),
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('password-strength__bar') }),
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('password-strength__bar') })),
                React.createElement("p", { className: vdl_prefix_1.vdlPrefix('password-strength__text') }, strengthText)),
            React.createElement("h5", { className: "vdl-password-strength__rule-heading" }, "Password must:"),
            React.createElement("ul", { className: "vdl-password-strength__rules" }, this.props.children)));
        var _b;
    };
    PasswordStrengthIndicator.propTypes = {
        strength: PropTypes.oneOf([0, 1, 2, 3, 4]).isRequired,
        className: PropTypes.string,
        strengthText: PropTypes.string
    };
    return PasswordStrengthIndicator;
}(React.PureComponent));
exports.PasswordStrengthIndicator = PasswordStrengthIndicator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/password-strength-indicator/password-strength-indicator.js
// module id = 586
// module chunks = 0 1 2 3 4 5 6